exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign-pad-wrapper[data-v-23ba04e6] {\n  background: #eee;\n}\n@media only screen and (min-width: 600px) {\n.sign-pad-wrapper[data-v-23ba04e6] {\n    height: 400px;\n}\n}\n@media only screen and (max-width: 599px) {\n.card-actions[data-v-23ba04e6] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: white;\n}\n}", ""]);

// exports
